import React, { useState, useContext }from 'react';
import { useIonRouter, IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonPage, IonList, IonIcon, IonRefresher, IonRefresherContent, IonText  } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { helpCircleOutline } from 'ionicons/icons';

//import { SelectDateRange } from '../components/SelectDateRange';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
//import { App_Header } from '../components/App_Header_jobBoard';
//import { App_Footer } from '../components/App_Footer';

import '../../../css/layout.css';
//import { OverviewBusinessSlides } from '../components/Tab_Overview';
import { Tab_Overview_Jobs } from '../components/Tab_Overview_Jobs';

//import {JobBoard_Management} from '../components/jobBoard_management_services';

import { Helpdesk_Public } from '../../../zInternal_Features/merchant/components/Modal_HelpChat_Public';

import { useHistory} from "react-router-dom";


 export function JobBoard_MerchantHomePage () {

    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [acctID, setAccountID ] = useState(authMerchant_objects.acctID);
    let [employeeID, setEmployeeID ] = useState(authMerchant_objects.employeeID);
    let [schema, setSchema ] = useState(authMerchant_objects.schema);
    let [access, setAccessRights ] = useState(authMerchant_objects.accessRights);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);

    let [overviewData, setOverviewData] = useState(true);
    let [operationsSlideData, setOperationsSlideData] = useState(false);
    // let [cleaningServicesData, setCleaningServicesData] = useState(false);
    // let [reservationsData, setReservationsData] = useState(false);
    // let [restaurantData, setRestaurantData] = useState(false);

    let [color_overview, setColor_overview] = useState('outline')
    let [color_operations, setColor_operations] = useState('clear')
    // let [color_cleaningServices, setColor_cleaningServices] = useState('clear')
    // let [color_reservations, setColor_reservations] = useState('clear')
    // let [color_restaurant, setColor_restaurant] = useState('clear')

    let [managementService_jobBoard, setManagementService_jobBoard] = useState(false);
    let [viewHelpDeskModal, setViewHelpDeskModal] = useState(false);

    let history = useHistory();
    let router = useIonRouter();


    function overviewHandler()
    {
        setOverviewData(true);
        setOperationsSlideData(false);
        // setCleaningServicesData(false);
        // setReservationsData(false);
        // setRestaurantData(false);

        setColor_overview('outline');
        setColor_operations('clear');
        // setColor_cleaningServices('clear');
        // setColor_reservations('clear');
        // setColor_restaurant('clear');


    }
    function checkInCheckOutHandler()
    {
        setOverviewData(false);
        setOperationsSlideData(true);
        // setCleaningServicesData(false);
        // setReservationsData(false);
        // setRestaurantData(false);

        setColor_overview('clear');
        setColor_operations('outline');
        // setColor_cleaningServices('clear');
        // setColor_reservations('clear');
        // setColor_restaurant('clear');

    }
    function cleaningServicesHandler()
    {
        // setOverviewData(false);
        // setCheckInCheckOutData(false);
        // setCleaningServicesData(true);
        // setReservationsData(false);
        // setRestaurantData(false);

        // setColor_overview('clear');
        // setColor_checkInCheckOut('clear');
        // setColor_cleaningServices('outline');
        // setColor_reservations('clear');
        // setColor_restaurant('clear');

    }
    function reservationsHandler()
    {
        // setOverviewData(false);
        // setCheckInCheckOutData(false);
        // setCleaningServicesData(false);
        // setReservationsData(true);
        // setRestaurantData(false);

        // setColor_overview('clear');
        // setColor_checkInCheckOut('clear');
        // setColor_cleaningServices('clear');
        // setColor_reservations('outline');
        // setColor_restaurant('clear');

    }

    function restaurantHandler()
    {
        // setOverviewData(false);
        // setCheckInCheckOutData(false);
        // setCleaningServicesData(false);
        // setReservationsData(false);
        // setRestaurantData(true);

        // setColor_overview('clear');
        // setColor_checkInCheckOut('clear');
        // setColor_cleaningServices('clear');
        // setColor_reservations('clear');
        // setColor_restaurant('outline');

    }


    const handleHomepage_zasava = () => {


        if (baseURL === "https://ghanaverified.com/") {
            window.location.href = "https://zasava.com";
            //history.push("https://zasava.com");

        } 
        else if (baseURL === "https://ghanaverifiedtest.com/") {
            window.location.href = "https://zasavatest.com";
           // history.push("https://zasavatest.com");
        }
  };

  function handleHomepage(event) {

    // alert(event);
    // alert(window.location.pathname)

        // history.push(event);
        router.push(event, 'forward', 'replace');
        //window.location = event;
    };


    function handleRefresh(event)
    {
        // Optional: Delay to show the spinner briefly
        setTimeout(() => {
            event.detail.complete();   // Stop the spinner
            window.location.reload();  // Reload the entire app
        }, 500);
    }
    

    //alert('In JobBoard_MerchantHomePage');   
    // // alert(acctID);
    // // alert(employeeID);
    // // //alert(schema);
    // // //alert(access);
    // alert(authMerchant_objects.selectedTutorial?.tutorial_id);
    // alert(authMerchant_objects.selectedTutorial?.details);
    // alert(authMerchant_objects.selectedTutorial?.details.step_1);
    // alert(authMerchant_objects.selectedTutorial?.details.step_2);
    // alert(authMerchant_objects.selectedTutorial?.details.step_3);
    // alert(authMerchant_objects.selectedTutorial?.details.step_4);


    return (
            <React.Fragment>

                <IonContent fullscreen>

                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent
                    pullingText="Pull to refresh the app"
                    refreshingSpinner="circles"
                    refreshingText="Refreshing app..."
                    />
                </IonRefresher>

                <IonHeader>

                <IonGrid className='grid_header'>
                    {authMerchant_objects.authenticated != null && <IonRow>
                        <IonCol style={{ textAlign: 'left', color: 'white' }} size='4'>
                            <IonTitle >{authMerchant_objects.employeeCompany}</IonTitle>
                        </IonCol>
                        <IonCol style={{ textAlign: 'left', color: 'white' }} size='6'>
                            <IonTitle >{authMerchant_objects.employeeFirstName + ' ' + authMerchant_objects.employeeLastName}</IonTitle>
                        </IonCol>
                        {authMerchant_objects.initialSetup?.details?.step_1 == false && <IonCol className='gh_top_links_col_right' size='2'>
                            <IonMenuButton className="custom-menu-button_initialSetup">M</IonMenuButton>
                        </IonCol>}
                        <IonCol className='gh_top_links_col_right' size='2'>
                            <IonMenuButton className="custom-menu-button">M</IonMenuButton>
                        </IonCol>
                    </IonRow>}
                    <IonRow>
                        <IonCol size = '12'>
                            <IonButton className= 'medium-button-tabs' fill={color_overview} onClick={() => overviewHandler()}> Overview </IonButton>
                        </IonCol>
                         {/*<IonCol size = '6'>
                            <IonButton className= 'medium-button-tabs' fill={color_operations} onClick={() => checkInCheckOutHandler()}> Orders </IonButton>
                        </IonCol>
                       <IonCol size = '3'>
                            <IonButton className= 'small-button-tabs' fill={color_cleaningServices} onClick={() => cleaningServicesHandler()}> Orders </IonButton>
                        </IonCol>
                        <IonCol size = '3'>
                            <IonButton className= 'small-button-tabs' fill={color_reservations} onClick={() => reservationsHandler()}> Reports </IonButton>
                        </IonCol>*/}
                    </IonRow>
                </IonGrid>
                </IonHeader>



                {overviewData == true && <Tab_Overview_Jobs openModal={ overviewData } closeModal={() => setOverviewData(false)}></Tab_Overview_Jobs>}
                {/*{operationsSlideData == true && <Tab_Operations openModal={ operationsSlideData } closeModal={() => setOperationsSlideData(false)}></Tab_Operations>}   

                {managementService_jobBoard == true && <JobBoard_Management openModal={managementService_jobBoard} closeModal={() => setManagementService_jobBoard(false)}></JobBoard_Management>}*/}

                {viewHelpDeskModal == true && <Helpdesk_Public openModal={viewHelpDeskModal} closeModal={() => setViewHelpDeskModal(false)}></Helpdesk_Public>}

                <IonFooter className='grid_footer'>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='2'>
                                    <IonButton className="custom-help-button" fill={'clear'} onClick={() => setViewHelpDeskModal(true)}>
                                            <IonText>HELP</IonText>
                                            <IonIcon icon={helpCircleOutline} />
                                    </IonButton>
                                </IonCol>
                                <IonCol size='8'>
                                    {(authMerchant_objects.accessRights[0] == 'admin' || authMerchant_objects.accessRights[0] == 'manager') && ( 
                                        (authMerchant_objects.initialSetup?.details?.step_1 == true && ( authMerchant_objects.initialSetup?.details?.step_2 == false || authMerchant_objects.initialSetup?.details?.step_3 == false || authMerchant_objects.initialSetup?.details?.step_4 == false ) ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "1" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "2" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "3" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "4" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "5" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "6" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "7" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "8" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "9" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "10" && authMerchant_objects.selectedTutorial?.details?.step_1 == false )
                                        ) ?
                                            <IonButton  className='small_button_initialSetup' auto-hide='false' onClick={ () => setManagementService_jobBoard(true)} >Management</IonButton> 
                                            :   <IonButton  className='small_button' auto-hide='false' onClick={ () => setManagementService_jobBoard(true)} >Management</IonButton> }
                                </IonCol>
                                <IonCol size='2'>
                                    <IonButton className="custom-public-button" fill={'clear'} onClick={() => handleHomepage('/home')}>
                                            <IonText style={{fontSize: '.5em'}}>PUBLIC</IonText>
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                           {/* {(authMerchant_objects.authenticated != null && (authMerchant_objects.acctID == "G1" || authMerchant_objects.acctID == "G27" || authMerchant_objects.acctID == "G23")) &&
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonButton className='small_button' onClick={() => handleHomepage_zasava()}>Zasava</IonButton>
                                    </IonCol>
                                 </IonRow>
                                } */}
                        </IonGrid>

                </IonFooter>

            </IonContent>
            </React.Fragment>

    );
};



export default JobBoard_MerchantHomePage;